import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AwsService } from '../../../providers/appsyncservice/aws.service';
import { UserTypePipePipe } from '../../../pipes/user-type-pipe.pipe';
import { positions } from '../../../models/positions';
declare var google: any;
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-rnc-cardata',
  templateUrl: './rnc-cardata.component.html',
  styleUrls: ['./rnc-cardata.component.css']
})
export class RncCarDataComponent implements OnInit {

    displayValue: Number = 0;
    carlist: any = [];
    cardataFm: FormGroup;

    constructor(public awserviceProvider: AwsService,
        private formBuilder: FormBuilder) {
        this.getAllData();
     }

    // GET DATA
     getAllData() {
         console.log('Car data getAllData')
         this.awserviceProvider.getCarListAll().then(data => {
          this.carlist = data
          console.log('response', data)
         })
     }
       
    // ADD DATA
     add() {
        this.displayValue = 1; 
        this.formInitilization()   
        console.log('this.cardataFm.value', this.cardataFm.value)
      }

      
      formInitilization() {
        this.cardataFm = new FormGroup({
          id: new FormControl(""),
          car_model: new FormControl(''),
          veh_reg_id : new FormControl(''),
          policy_no: new FormControl(''),
          policy_from : new FormControl(''),
          policy_to : new FormControl(''),
          agency_name : new FormControl(''),
          map_user_id : new FormControl(''),
        });
      }

      // EDIT DATA
      editData(cardata) {
          console.log('editData', cardata)
          this.displayValue = 1; 
          this.cardataFm.setValue(
          {
            id: cardata.id,
            car_model: cardata.car_model,
            veh_reg_id : cardata.veh_reg_id,
            policy_no: cardata.policy_no,
            policy_from : cardata.policy_from,
            policy_to : cardata.policy_to,
            agency_name : cardata.agency_name,
            map_user_id : cardata.map_user_id,
          });
      }

      // SAVE DATA
      onSubmit() {
        console.log('Add - car data', this.cardataFm.value.id)
        if (this.cardataFm.value.id !== '' ) {  
        // # UPDATE RECORD #
        this.awserviceProvider.UpdateCarData(this.cardataFm.value).then(result => {
          this.getAllData();
          this.displayValue = 0;     
         }).catch(err => {
           console.log("err",err)
         });
        } else {
         // # CREATE RECORD #
         this.awserviceProvider.CreateCarData(this.cardataFm.value).then(result => {
          console.log('createdata-car', result)
          this.getAllData();
          this.displayValue = 0;     
         }).catch(err => {
           console.log("err",err)
         });
        }
      }

      // REFER FROM SC-USER-TRIP - (MASTER)
      deleteData(cardata) {        
        this.awserviceProvider.deleteCarData(cardata.id).then(res => {
          this.getAllData()
        }).catch(err => {
          console.log(err);
        });            
      }

     ngOnInit() {
         this.displayValue = 0;
         this.formInitilization()
         console.log('car data module init')
     }
}